import { render, staticRenderFns } from "./ViTeacherAcademicManagementHome.vue?vue&type=template&id=6938da5e"
import script from "./ViTeacherAcademicManagementHome.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports